import { Flex, Image, Select, Text } from '@oplog/express';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '../../../i18n';

interface ILangSelectionDropdown {
  isExpanded?: boolean;
  menuOpen?: boolean;
  setMenuOpen?: (status: boolean) => void;
}

const LangSelectionDropdown: React.FC<ILangSelectionDropdown> = ({ isExpanded, menuOpen, setMenuOpen }) => {
  const { t } = useTranslation();

  useEffect(() => {
    !isExpanded && setMenuOpen?.(false);
  }, [isExpanded]);

  const languages = [
    {
      value: 'tr-TR',
      label: t('SideBar.TurkishLabel'),
    },
    {
      value: 'en-US',
      label: t('SideBar.EnglishLabel'),
    },
  ];

  const languageOptions = () => {
    const langs: any[] = [];
    languages.map(lang =>
      langs.push({
        value: lang?.value,
        label: (
          <Flex>
            <Image mr={11} width={32} src={`/images/flags/${lang.value}.svg`} />
            <Text fontSize={16}>{lang?.label}</Text>
          </Flex>
        ),
      })
    );
    return langs;
  };

  const handleChange = e => {
    i18n.changeLanguage(e.value.value);
    setMenuOpen?.(false);
    window.location.reload();
  };

  return (
    <Flex width={isExpanded === false ? 52 : 1} onClick={() => (menuOpen ? setMenuOpen?.(false) : setMenuOpen?.(true))}>
      <Select
        options={languageOptions()}
        value={i18n.language}
        onChange={handleChange}
        hideIndicators={isExpanded === false}
        isSearchable={false}
        menuIsOpen={menuOpen}
        styles={{
          valueContainer: (base: any) => ({
            ...base,
            flexWrap: 'nowrap',
          }),
        }}
      />
    </Flex>
  );
};

export default LangSelectionDropdown;